import { useMemo } from 'react';
import {
  ColumnTable,
  CellFormatOptions,
  useWindowSize,
  useMobile,
} from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Report } from '../../../../../types/Reports';
import { TextEllipsis } from '../../../../../components/text';
import ReportActionsCell from '../parts/ReportActionsCell/ReportActionsCell';

type UseReportsColumnsProps = {
  onPressDownload?: (row: Report) => void;
};

const prefix = 'reports';

export const useReportsColumns = (props: UseReportsColumnsProps) => {
  const { t } = useTranslation();
  const { width: windowWidth } = useWindowSize();
  const isMobile = useMobile();

  const columns = useMemo<ColumnTable<Report>[]>(
    () => [
      {
        headerText: t(`${prefix}.tableColumns.report`),
        columnName: 'name',
      },
      {
        headerText: t(`${prefix}.tableColumns.description`),
        columnName: 'description',
        cellFormat: (data: CellFormatOptions<Report>) => {
          return (
            <TextEllipsis
              key={data.index}
              textWidth={windowWidth ? windowWidth * 0.35 : 320}
            >
              {data.row.description}
            </TextEllipsis>
          );
        },
      },
      {
        headerText: t(`${prefix}.tableColumns.action`),
        columnName: 'action',
        width: !isMobile ? '300px' : undefined,
        cellFormat: (data: CellFormatOptions<Report>) => (
          <ReportActionsCell
            report={data.row}
            onPressDownload={() =>
              !!props.onPressDownload && props.onPressDownload(data.row)
            }
          />
        ),
      },
    ],
    [t, props, isMobile, windowWidth],
  );

  return columns;
};
